import { apiFetch } from '@/api/apiFetch';
import { t } from '@/translations/i18n';
import type { EProductImageType } from '@/typescript/enums/EProductImageType';

// Product image are cut images and help grids
async function postProductImage(file: File, productId: number, type: EProductImageType): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    formData.append('product', productId.toString());
    const response = await apiFetch(`/product_images/`, { method: 'POST', body: formData });
    if (!response.ok) {
        throw new Error(t('upload_image_error'));
    }
    const responseBody = await response.json();
    return responseBody.uuid;
}

async function fetchProductImage(imageUUID: string) {
    const response = await apiFetch(`/product_images/${imageUUID}`);
    if (!response.ok) {
        throw new Error(t('image_load_error'));
    }
    const blob = response.blob();
    return blob;
}

async function deleteProductImage(imageUUID: string) {
    const response = await apiFetch(`/product_images/${imageUUID}`, { method: 'DELETE' });
    if (!response.ok) {
        throw new Error(t('image_delete_error'));
    }
}
export { deleteProductImage, fetchProductImage, postProductImage };
